import { Component, OnInit } from "@angular/core";
import { LayoutService } from "../../../../@lhacksrt/services/layout/layout.service";


@Component({
    selector: 'aside-footer',
    templateUrl: './aside-footer.component.html',
    standalone: false
})
export class AsideFooterComponent implements OnInit {

    isSmallScreen: boolean = false;

    get isClassyLayout(): boolean {
        return this._loayoutService.isClassyLayout;
    }

    constructor(
        private _loayoutService: LayoutService
    ) { }

    ngOnInit() {
        this.isSmallScreen = this._loayoutService.isScreenSmall;
    }
}